import { c as createFocusTrap } from './focus-trap.esm-DqbZs9d4.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

/**
 * Toggle the dialog.
 * @param {HTMLElement} dialog - The dialog to toggle.
 */
function toggleDialog(dialog) {
  // If the dialog is already open, close it
  if (dialog.open) {
    // Deactivate the focus trap
    dialog.trap.deactivate();

    // Close the dialog after the focus trap is deactivated
    setTimeout(() => {
      closeDialog(dialog);
    }, 100);
  } else {
    // If the dialog is not open, open it
    openDialog(dialog);

    // Create the focus trap if it doesn't exist
    if (!dialog.trap) {
      dialog.trap = createFocusTrap(dialog, {
        // Allow clicks outside the dialog to close the dialog
        allowOutsideClick: true,
        initialFocus: false,
      });
    }
    // Activate the focus trap
    dialog.trap.activate();
  }
}

function openDialog(dialog) {
  const template = dialog.querySelector('template');
  if (template) {
    const clone = template.content.cloneNode(true);
    dialog.appendChild(clone);

    // Remove inline display and visibility styles from images in the newly added content
    const images = dialog.querySelectorAll('img');
    images.forEach((img) => {
      img.style.removeProperty('display');
      img.style.removeProperty('visibility');
    });
  }
  dialog.showModal();

  // Prevent focus on the first element by blurring any focused element
  document.activeElement?.blur();
}

function closeDialog(dialog) {
  const template = dialog.querySelector('template');
  if (template) {
    const body = dialog.querySelector('.dialog__body');
    if (body) body.remove();
  }
  dialog.close();
}

/**
 * Listen for dialog:open events
 */
Pubsub.subscribe('dialog:open', ({ dialogId }) => {
  const dialog = document.getElementById(dialogId);
  if (dialog) toggleDialog(dialog);
});

/**
 * Listen for dialog:close events
 */
Pubsub.subscribe('dialog:close', ({ dialogId }) => {
  const dialog = document.getElementById(dialogId);
  if (dialog) toggleDialog(dialog);
});

/**
 * Listen for key:escape events
 */
Pubsub.subscribe('key:escape', () => {
  const dialog = document.querySelector('dialog[open]');
  if (dialog) toggleDialog(dialog);
});

Pubsub.subscribe('cart:add', () => {
  const dialogs = document.querySelectorAll('dialog[open]');
  dialogs.forEach((dialog) => toggleDialog(dialog));
});

/**
 * Listen for clicks on data-dialog-controller
 */
document.addEventListener('click', (event) => {
  const target = event.target;

  // Handle dialog controllers
  if (target.closest('[data-dialog-controller]')) {
    const dialogId = target.closest('[data-dialog-controller]').getAttribute('aria-controls');
    const dialog = document.getElementById(dialogId);
    if (!dialog) {
      console.error(`Dialog with id '${dialogId}' not found`);
      return;
    }

    toggleDialog(dialog);
  }

  // Handle click on dialog background to close
  if (target.nodeName === 'DIALOG') {
    closeDialog(target);
  }
});
